import { NotificationEntity } from 'types/notifications';
import { createAction } from 'redux-actions';

export type UpdateNotificationsPayload = NotificationEntity[];

export const getNotifications = createAction('GET_NOTIFICATIONS');

export const cleanNotifications = createAction('CLEAN_NOTIFICATIONS');

export const updateNotifications = createAction<UpdateNotificationsPayload>('UPDATE_NOTIFICATIONS');
